<!-- 座席 -->
<template>
  <div v-for="(seat, index) in seats" :key="index" class="row">
    <div class="th cell"><span v-if="index == 0">座席</span></div>
    <div class="cell">
      <!-- 購入済みの場合のみ、座席番号を表示 -->
      {{ seat.car_number }}号車
      <span v-if="isPurchased">{{ seat.display_number }}</span>
      <span v-if="seat.price_division == 'adult'">(おとな)</span>
      <span v-else-if="seat.price_division == 'child'">(こども)</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "StoreSeats",
  props: {
    seats: {
      type: Array,
      required: true,
    },
    isPurchased: {
      type: Boolean,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.row {
  display: table-row;
}
.cell {
  font-weight: bold;
  display: table-cell;
  padding: 8px;
}
.th {
  font-weight: 100;
  padding-right: 14px;
  color: grey;
  padding-right: 14px;
}
</style>
